<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="body-panel-control-separator">
                <div class="control-block-left">

                    <div class="flex">
                        <project-select :user="info.User" @onChange="onProjectChange" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>

                        <div class="input-date-lbl margin-right-10">
                            <input-date name="dateStart" v-model="dateStart" @input="reload" class="input-text input-date"></input-date>
                        </div>
                        <span class="margin-right-10 margin-top-5">-</span>
                        <div class="input-date-lbl">
                            <input-date name="dateEnd" v-model="dateEnd" @input="reload" class="input-text input-date"></input-date>
                        </div>

                    </div>

                </div>
                <div class="control-block-right">
                    <div class="flex">
                        <div class="form-field ">
                            <div class="btns flex" v-if="project != null">
                                <button class="btn" @click="onExportByReports()" v-if="analyticsReportEnabled">
                                    Выгрузка по отчетам
                                </button>
                                <button class="btn" @click="onExport()" v-if="project.AnalyticsReportEnabled && analyticsSettingsForRole.ReportEnabled">
                                    Экспорт
                                </button>
                                <drop-down class="margin-right-20"
                                           v-if="analyticsSettingsForRole.SwitcherEnabled"
                                           v-model="measureType"
                                           :items="measureTypes"
                                           :dataField="'Value'"
                                           :textField="'Name'" @change="reload"></drop-down>
                                <drop-down name="units"
                                           v-if="analyticsSettingsForRole.PeriodsEnabled"
                                           :class="['margin-right-20 stick-right']"
                                           v-model="unit"
                                           :items="units"
                                           :dataField="'Value'"
                                           :textField="'Name'"
                                           @change="reload"></drop-down>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-panel-control-separator">
                <complex-filter
                        ref="complexFilter"
                        :filters="filters"
                        :searchFunction="searchFunction"
                        :tableName="'[dbo].[TradePoint]'"
                        :withTableNameInClause="true"
                        @onFilterChange="onFilterChange">
                </complex-filter>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page" v-if="analyticsSettingsForRole">
            <div class="block-in-page" style="height:100%">
                <chart ref="chartObj"
                       v-if="chartOptions && analyticsSettingsForRole.DataTypeId === 0"
                       :chartData="chartData"
                       :chartOptions="chartOptions"
                       :controlClick="analyticsSettingsForRole.DetailEnabled === true"
                       @onBarClick="onBarClick"></chart>

                <table class="table-view" v-if="tableData && analyticsSettingsForRole.DataTypeId === 1">
                    <thead>
                        <tr class="heading">
                            <th v-for="(type, name) of tableData.Columns" v-if="name !== 'CustomField'">
                                {{ name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(tableRow, index) of tableData.Table" @click.stop="onTableClick(tableRow, index)" :class="[{'selected': tableRow.Expanded}, {'details': tableRow.DetailsTable }]">
                            <template v-if="tableRow.DetailsTable">
                                <td :colspan="tableData.ColumnsLength">
                                    <table class="table-details">
                                        <thead>
                                            <tr>
                                                <th v-for="(type, name) of tableRow.DetailsTable.Columns">
                                                    {{ name }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="detailsRow of tableRow.DetailsTable.Table">
                                                <td v-for="(value, name) of detailsRow" :class="getTdClass(tableRow.DetailsTable.Columns[name])">
                                                    {{ formatTableDetailsValue(value, tableRow.DetailsTable.Columns[name]) }}
                                                </td>
                                            </tr>
                                            <tr v-if="!tableRow.DetailsTable.Table.length">
                                                <td :colspan="tableRow.DetailsTable.ColumnsLength" style="text-align: center;">
                                                    Нет данных
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                            <template v-else>
                                <td v-for="(value, name) of tableRow" :class="getTdClass(tableData.Columns[name])" v-if="name !== 'CustomField' && name !== 'Expanded'">
                                    {{ formatTableValue(value, tableData.Columns[name]) }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>

                <div id="chartDetails" class="chart-details-container" :style="{display: (chartDetailsData ? 'block': 'none') }">
                    <template v-if="chartDetailsData">
                        <table class="chart-details-table">
                            <thead>
                            <tr class="">
                                <th v-for="(type, name) of chartDetailsData.Columns">
                                    {{ name }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="detailsRow of chartDetailsData.Table">
                                <td v-for="(value, name) of detailsRow" :class="getTdClass(chartDetailsData.Columns[name])">
                                    {{ formatTableDetailsValue(value, chartDetailsData.Columns[name]) }}
                                </td>
                            </tr>
                            <tr v-if="!chartDetailsData.Table.length">
                                <td :colspan="chartDetailsData.ColumnsLength" style="text-align: center;">
                                    Нет данных
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
            </div>
        </div>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import moment from 'moment'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import config from '../config'
    import UI from '../helpers/ui-helpers'

    let backendApi = new BackendApi();

    let porjectIdWorx = 25;

    export default {
        name: "analytics",

        props: ['info'],

        mixins: [projectMixin],

        data(){
            return {
                filter: null,
                dateStart: null,
                dateEnd: null,
                chartData: null,
                chartOptions: null,
                unit: 'day',
                roles: [],
                filters: [],
                units: [
                    {Value: 'day', Name: 'День'},
                    {Value: 'week', Name: 'Неделя'},
                    {Value: 'month', Name: 'Месяц'}
                ],
                project: null,
                measureType: null,
                measureTypes: [
                    {Value: 'Рубли', Name: 'Рубли'},
                    {Value: 'Штуки', Name: 'Штуки'},
                ],
                tableData: null,
                tooltipHtml: null,
                chartDetailsData: null
            }
        },

        computed:{
            analyticsSettingsForRole(){
                if(!this.project || !this.info){
                    return null;
                }
                if(this.info.User.MainRole === 'administrators'){
                    return {
                        DataTypeId: 0,
                        ReportEnabled: true,
                        SwitcherEnabled: true,
                        PeriodsEnabled: true,
                        DetailEnabled: false
                    }
                }
                let projectAnalyticsRoles = this.project.ProjectAnalyticsRoles.find(x => x.RoleId === this.info.User.DynamicRole.Id);
                return projectAnalyticsRoles || {
                    DataTypeId: 0,
                    ReportEnabled: true,
                    SwitcherEnabled: true,
                    PeriodsEnabled: true,
                    DetailEnabled: false
                };
            },

            analyticsReportEnabled() {
                if (this.info && this.projectId === porjectIdWorx)
                    return this.info.User.MainRole === 'administrators' || (this.info.User.DynamicRole && this.info.User.DynamicRole.Name === 'Клиент');
                else
                    return null;
            }
        },

        methods: {
            getCurrencyNameByCountry(countryId) {
              switch (countryId) {
                case 1: // Россия
                  return 'Рубли';
                case 2: // Беларусь
                  return 'Белорусские рубли';
                case 3: // Казахстан
                  return 'Тенге';
                default:
                  return 'Рубли'; // Значение по умолчанию
              }
            },

            getTdClass(type) {
                switch (type) {
                    case 'System.Int16':
                    case 'System.Int32':
                        return 'id';
                    case 'System.String':
                        return 'string';
                    case 'System.Datetime':
                        return 'datetime';
                    case 'System.Double':
                    case 'System.Decimal':
                        return 'value';
                    default:
                        return null;
                }
            },

            formatTableValue(value, type){
                if(type === 'System.DateTime'){
                    return moment(value).format('DD.MM.YYYY HH:mm');
                }
                return value;
            },

            formatTableDetailsValue(value, type){
                if(type === 'System.DateTime'){
                    return moment(value).format('DD.MM.YYYY');
                }
                return value;
            },

            onTableClick(tableRow, index) {
                let vm = this;
                if(this.analyticsSettingsForRole.DetailEnabled !== true || tableRow.DetailsTable){
                    return;
                }

                for (let i = 0; i < vm.tableData.Table.length; i++) {
                    if (i !== index && vm.tableData.Table[i].Expanded === true) {
                        vm.tableData.Table[i].Expanded = false;
                        vm.tableData.Table.splice(i + 1, 1);
                        if(index > i){
                            index--;
                        }
                    }
                }

                if (!tableRow.Expanded) {
                    tableRow.Expanded = true;

                    let projectId = vm.projectId
                    let timeZone = new Date().getTimezoneOffset();
                    let dateStart = vm.dateStart && moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                    let dateEnd = vm.dateEnd && moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                    let filterFormatted = '';
                    if(vm.filter){
                        filterFormatted = vm.filter.map(x => {return JSON.stringify(x)});
                    }
                    let measureType = null;
                    if(vm.analyticsSettingsForRole.SwitcherEnabled === true){
                        measureType = vm.measureType;
                    }
                    let skuId = null;
                    if(vm.project.Id === 7){
                        skuId = vm.skuId;
                    }
                    let asDataTable = vm.analyticsSettingsForRole.DataTypeId === 1;

                    UI.blockUI('.table-view:first');
                    vm.callApiWrapper(backendApi.analyticsGetDetails(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId, asDataTable, tableRow.CustomField)).then(function (resp) {
                        console.info('resp.data:', resp.data);
                        vm.tableData.Table.splice(index+1, 0, {
                            DetailsTable: Object.assign(resp.data, {ColumnsLength: Object.keys(resp.data.Columns).length})
                        });

                        UI.unblockUI('.table-view:first');
                    });

                }else{
                    tableRow.Expanded = false;
                    vm.tableData.Table.splice(index+1, 1);
                }
            },

            reload(){
                this.loadData();
            },

            loadRoles() {
                let vm = this;
                let projectId = vm.projectId;
                vm.filters = [
                    {
                    Value: 'Name', Name: 'Название'
                    },
                    {
                        Value: 'Region', Name: 'Регион'
                    },
                    {
                        Value: 'Area', Name: 'Область'
                    },
                    {
                        Value: 'City', Name: 'Город'
                    },
                    {
                        Value: 'Address', Name: 'Адрес'
                    },
                    {Value: 'ExternalId', Name: 'Внешний ID'}
                ];
                if(projectId === 30) {
                    return new Promise(resolve => resolve());
                } else {
                    return this.callApiWrapper(backendApi.rolesList(projectId))
                        .then(function (resp) {
                            if(resp.data) {

                                vm.roles = resp.data.Roles;

                                /*
                                для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                                если роль не связана с ТТ, то она видит все роли связанные с ТТ
                                если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                                */
                                if(vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                    //alert()
                                    for(let r = 0; r < vm.roles.length; r++) {
                                        if(!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                            vm.filters.push({
                                                Value: 'TradePointRole_' + vm.roles[r].Id,
                                                Name: vm.roles[r].Name
                                            });
                                        }
                                    }
                                }
                                else {

                                    for(let r = 0; r < vm.roles.length; r++) {
                                        if(!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess) && vm.info.User.DynamicRole.Order < vm.roles[r].Order) {

                                            vm.filters.push({
                                                Value: 'TradePointRole_' + vm.roles[r].Id,
                                                Name: vm.roles[r].Name
                                            });
                                        }
                                    }
                                }
                            }
                        });
                }
            },

            loadProject(){
                let vm = this;

                return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                    if (resp.data) {
                        vm.project = resp.data;
                        //vm.analyticsSettingsForRole = vm.project.ProjectAnalyticsRoles.find(x => x.RoleId === vm.info.User.DynamicRole.Id);
                    }
                });
            },

            loadData(){
                let vm = this;

                let projectId = vm.projectId
                let timeZone = new Date().getTimezoneOffset();
                let dateStart = vm.dateStart && moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let dateEnd = vm.dateEnd && moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let filterFormatted = '';
                if(vm.filter){
                    filterFormatted = vm.filter.map(x => {return JSON.stringify(x)});
                }

                let measureType = null;
                if(vm.analyticsSettingsForRole.SwitcherEnabled === true){
                    measureType = vm.measureType;
                }
                let skuId = null;
                if(vm.project.Id === 7){
                    skuId = vm.skuId;
                }

                //vm.analyticsSettingsForRole.DataTypeId = 1;
                let asDataTable = vm.analyticsSettingsForRole.DataTypeId === 1;

                this.callApiWrapper(backendApi.analyticsGetData(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId, asDataTable)).then(function (resp) {
                    if(!asDataTable){
                        let labels = resp.data.map(x => x.Name);
                        let values = resp.data.map(x => x.Value);

                        vm.chartData = {
                            labels: labels,
                            datasets: [
                                {
                                    label: 'Сумма продаж',
                                    data: values,
                                    backgroundColor: vm.project.AnalyticsColumnsColor || 'rgba(255, 99, 132, 0.5)',
                                    borderColor: vm.project.AnalyticsBorderColor || 'rgba(255, 99, 132, 1)',
                                    borderWidth: 1
                                }
                            ]
                        };
                    }else{
                        vm.tableData = resp.data;
                        vm.tableData.ColumnsLength = Object.keys(vm.tableData.Columns).filter(x => x !== 'CustomField').length;
                    }
                });
            },

            loadSku() {
                let vm = this;

                vm.units.push({
                    Value: 'sku',
                    Name: 'Sku'
                });
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {

                let projectId = this.projectId;
                let filterFormatted = '';
                if(filters){
                    filterFormatted = filters.map(x => {return JSON.stringify(x)});
                }

                this.callApiWrapper(backendApi.tradePointDistinctValues(columnName, projectId, search, filterFormatted, (searchPage - 1) * 30, 30))
                    .then(function (resp) {
                        callback(resp.data);
                    })

            },

            onProjectChange(item){
                let vm = this;
                vm.projectId = item.Id;

                vm.filter = null;
                vm.$refs.complexFilter.clear();

                Promise.all([vm.loadRoles(), vm.loadProject()]).then(function(){
                    vm.updateMeasureTypes(); // Обновляем measureTypes при изменении проекта
                    vm.loadData();
                    if (vm.projectId === 7 || vm.projectId === 8){
                        vm.loadSku();
                    }else{
                        vm.units = [
                            {Value: 'day', Name: 'День'},
                            {Value: 'week', Name: 'Неделя'},
                            {Value: 'month', Name: 'Месяц'}
                        ];
                    }
                });

                vm.$emit('user-updated');
            },

            updateMeasureTypes() {
              if (this.project) {
                const currencyName = this.getCurrencyNameByCountry(this.project.CountryId);
                this.measureTypes = [
                  { Value: 'Рубли', Name: currencyName },
                  { Value: 'Штуки', Name: 'Штуки' },
                ];
              }
            },

            onFilterChange(filter) {
                //console.info('onFilterChange -> filter', filter);
                this.filter = filter;
                this.loadData();
            },

            onExport() {
                let vm = this;

                let projectId = vm.projectId;
                let dateStart = vm.dateStart && moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = vm.dateEnd && moment(vm.dateEnd, 'DD.MM.YYYY').format();

                let filterFormatted = '';
                if(vm.filter){
                    filterFormatted = vm.filter.map(x => {return JSON.stringify(x)});
                }
                let measureType = null;
                if(vm.analyticsSettingsForRole.SwitcherEnabled === true){
                    measureType = vm.measureType;
                }
                let skuId = null;
                if(vm.project.Id === 7){
                    skuId = vm.skuId;
                }

                UI.blockUI('#app');
                this.callApiWrapper(backendApi.analyticsExport(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                            console.info('resp', resp);
                        }
                        else {
                            let exportFile = resp.data;
                            if(exportFile != null)
                            {
                                //location.href = config.apiUrl + '/api/stats/exported?exportFile=' + exportFile;
                                UI.downloadFileByBytes(resp.data, "Аналитика.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onExportByReports() {
                let vm = this;

                let filterFormatted = '';
                if (vm.filter) {
                    filterFormatted = vm.filter.map(x => {return JSON.stringify(x)});
                }
                let measureType = null;
                if (vm.analyticsSettingsForRole.SwitcherEnabled === true) {
                    measureType = vm.measureType;
                }
                let skuId = null;
                if (vm.project.Id === 7) {
                    skuId = vm.skuId;
                }
                let dateStart = vm.dateStart && moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = vm.dateEnd && moment(vm.dateEnd, 'DD.MM.YYYY').format();

                UI.blockUI('#app');
                this.callApiWrapper(backendApi.analyticsExportByReports(vm.projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                            console.info('resp', resp);
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(resp.data, "Аналитика по отчётам.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            // [datasetIndex, dataIndex, clientX, clientY]
            onBarClick(args){
                let vm = this;
                if(args == null){
                    vm.chartDetailsData = null;
                    return;
                }

                let label = this.chartData.labels[args[1]];
                let projectId = vm.projectId
                let timeZone = new Date().getTimezoneOffset();
                let dateStart = vm.dateStart && moment(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let dateEnd = vm.dateEnd && moment(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                let filterFormatted = '';
                if(vm.filter){
                    filterFormatted = vm.filter.map(x => {return JSON.stringify(x)});
                }
                let measureType = null;
                if(vm.analyticsSettingsForRole.SwitcherEnabled === true){
                    measureType = vm.measureType;
                }
                let skuId = null;
                if(vm.project.Id === 7){
                    skuId = vm.skuId;
                }
                let asDataTable = vm.analyticsSettingsForRole.DataTypeId === 1;

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.analyticsGetDetails(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId, asDataTable, label)).then(function (resp) {
                    //console.info('resp.data:', resp.data);
                    vm.chartDetailsData = resp.data;

                    vm.$nextTick(() => {
                        let leftPos = args[2], topPos = args[3];
                        let docWidth = $(document).width(), docHeight = $(document).height();
                        let elementWidth = $('#chartDetails').width(), elementHeight = $('#chartDetails').height();

                        if (leftPos + elementWidth > docWidth - 50) {
                            leftPos-=elementWidth;
                        }
                        if (topPos + elementHeight > docHeight - 50) {
                            topPos -= elementHeight;
                        }

                        $('#chartDetails').css({
                            left: leftPos + 'px',
                            top: topPos + 'px'
                        }).appendTo('body');
                    });

                    UI.unblockUI('#app');
                });
            }
        },

        mounted(){
            let vm = this;

            vm.dateStart = vm.formatDate(moment().startOf('month'));
            vm.dateEnd = vm.formatDate(moment().endOf('month'));

            let options = {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                maintainAspectRatio: false,
                responsive: true,
                stacked: false,
                defaultFontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    /*
                    custom: function(tooltipModel){
                        let tooltipEl = document.getElementById('chartjs-tooltip');
                        // Hide if no tooltip
                        if (tooltipEl && tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            vm.$refs['chartObj'].update({
                                tooltips:{
                                    enabled: true
                                }
                            });
                            return;
                        }

                        if(vm.tooltipHtml != null){
                            if (!tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'chartjs-tooltip';
                                //tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
                                tooltipEl.style.borderRadius = '3px';
                                tooltipEl.style.color = 'white';
                                tooltipEl.style.padding = 0;
                                tooltipEl.style.opacity = 1;
                                tooltipEl.style.pointerEvents = 'none';
                                tooltipEl.style.position = 'absolute';
                                tooltipEl.style.transform = 'translate(-50%, 0)';
                                tooltipEl.style.transition = 'all .1s ease';
                                tooltipEl.innerHTML = vm.tooltipHtml;
                                document.body.appendChild(tooltipEl);
                            }

                            // Set caret Position
                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }

                            // `this` will be the overall tooltip
                            let position = this._chart.canvas.getBoundingClientRect();
                            console.info('position:', position);

                            // Display, position, and set styles for font
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                            tooltipEl.style.padding = '0px';
                            tooltipEl.style.pointerEvents = 'none';
                            tooltipEl.style.opacity = 1;

                            vm.tooltipHtml = null;
                        }
                    },
                    */
                    callbacks: {
                        label: function (tooltipItem, data) {
                            let label = data.datasets[tooltipItem.datasetIndex].label || '';
                            label += ': ' + vm.formatInt(tooltipItem.yLabel) ;
                            return label;
                        }
                    }
                }
            };
            vm.chartOptions = options;

            Promise.all([vm.loadRoles(), vm.loadProject()]).then(function(){
                vm.updateMeasureTypes();
                vm.loadData();

                if (vm.projectId === 7 || vm.projectId === 8){
                    vm.loadSku();
                }
            });

            $(document).on('click', function(){
                vm.chartDetailsData = null;
            })
        }
    }
</script>

<style>
    .dropdown-block.stick-right .dropdown-list{right:0; left: auto !important;}
    .table-view thead{display: table-header-group;}
</style>


// WEBPACK FOOTER //
// Content/src/views/Analytics.vue